<template>
 <div class="content">
   <div class="water-temperature-station">
     <div class="publish-time" v-if="result && result.length > 0">
       <div>
         {{ $moment(result[activateIndex].dtime).format('YYYY-MM-DD HH:mm')  }}更新
       </div>
     </div>
     <div class="water-temperature-station-wrap" v-if="result && result.length > 0">
       <div class="station_tabs">
         <div class="station_name" @click="handleChangeStation(index)" v-for="(item,index) in result" :key="index" :class="{activate: activateIndex === index}">
           {{item.staname}}
         </div>
       </div>
       <div class="station_data">
         <div class="data_cards" v-if="result[activateIndex].type === 'sc'">
           <div class="data_card">
             <div class="label">水面温度</div>
             <div class="value">{{formatVal(result[activateIndex].t)}}°C</div>
           </div>
           <div class="data_card">
             <div class="label">1m水温</div>
             <div class="value">{{formatVal(result[activateIndex].t1)}}°C</div>
           </div>
           <div class="data_card">
             <div class="label">2m水温</div>
             <div class="value">{{formatVal(result[activateIndex].t2)}}°C</div>
           </div>
           <div class="data_card">
             <div class="label">PH</div>
             <div class="value">{{formatVal(result[activateIndex].ph)}}</div>
           </div>
           <div class="data_card">
             <div class="label">溶解氧</div>
             <div class="value">{{formatVal(result[activateIndex].ddo)}}mg/L</div>
           </div>
           <div class="data_card">
             <div class="label">氨氮</div>
             <div class="value">{{formatVal(result[activateIndex].nh)}}mg/L</div>
           </div>
         </div>
         <div class="data_cards" v-if="result[activateIndex].type === 'zz'">
           <div class="data_card">
             <div class="label">光照强度</div>
             <div class="value">{{formatVal(result[activateIndex].light)}}lux</div>
           </div>
           <div class="data_card">
             <div class="label">湿度</div>
             <div class="value">{{formatVal(result[activateIndex].rh)}}%</div>
           </div>
         </div>
       </div>
     </div>
 </div>
 </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['params', 'forecastType', 'cardEchart'],
  name: 'water-temperature-station',
  data () {
    return {
      result: [],
      activateIndex: 0
    }
  },
  computed: {
    ...mapState('home', ['activeCountyId', 'unitZjStationDataResult'])
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getStationData()
          })
        }, 100)
      },
      immediate: true
    },
    unitZjStationDataResult: {
      handler () {
        this.$nextTick(() => {
          this.getStationData()
        })
      },
      deep: true
    }
  },
  methods: {
    async getStationData () {
      const result = this.unitZjStationDataResult
      this.result = result
    },
    handleChangeStation (index) {
      this.activateIndex = index
    },
    formatVal (val) {
      if (!val) {
        return '--'
      }
      return val
    }
  }
}
</script>

<style  lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  overflow: hidden;
  .water-temperature-station {
    .water-temperature-station-wrap {
      display: flex;
      flex-direction: column;
      .station_tabs {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 1.2vh;
        margin-top: 0.4vh;
        .station_name {
          color: #96ACBF;
          text-shadow: 0px 2px 1px rgba(8,42,73,0.37);
          margin-right: 0.8vw;
          font-size: 0.85vw;
          cursor: default;
        }
        .activate {
          color: #78E4F2;
        }
      }

      .station_data {
        width: 100%;
        .data_cards {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .data_card {
            position: relative;
            z-index: 0; /* 确保子元素在伪元素之上 */
            margin-bottom: 1vh;
            box-sizing: border-box;
            padding: 0.6vh 0.6vw;

            display: flex;
            width: 49%;
            justify-content: space-between;
            .label {
              color: #D3DCE4;
            }
            .value {
              color: #B6E6FD;
              font-weight: 600;
            }
          }
          .data_card  ::before {
            opacity: 0.41;
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 6px;
            border: 2px solid;
            z-index: -1; /* 伪元素位于父元素之下 */
            background: linear-gradient( 135deg, rgba(106,152,199,0.47) 0%, rgba(87,86,141,0.48) 51%, rgba(60,108,112,0.5) 100%);
            border-image: linear-gradient(135deg, rgba(112, 176, 247, 1), rgba(78, 133, 211, 0), rgba(112, 178, 250, 1)) 2 2;
          }
        }
      }
    }
  }
  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
